module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/plane.svg?a2188e7a129f001ff2fa7c50c6f8c2d5";